export const GLOBAL_STYLES = {
  body: {
    bg: "white",
  },
};
